import styled from "styled-components";
export const StyledTabs = styled.div.withConfig({ displayName: "StyledTabs_APC-7281-productShell", componentId: "sc-14svno4" })({
    width: "100%",
});
//# sourceMappingURL=Tabs.style.js.map